import { FC } from 'react';
import colors from 'styles/_colors.module.scss';

type Props = {
  background?: string;
  color?: string;
};

const AvatarSix: FC<Props> = ({
  background = colors['--slate'],
  color = colors['--body'],
}) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ background, borderRadius: '9px' }}
  >
    <path
      d="M22.4148 22.5576C22.4148 22.1083 22.824 21.744 23.3287 21.744H23.9684C24.4731 21.744 24.8822 21.3798 24.8822 20.9305L24.8822 17.0087C24.8822 16.5594 24.4731 16.1951 23.9684 16.1951H23.2373C22.7326 16.1951 22.3235 16.5594 22.3235 17.0087L22.3235 20.9305C22.3235 21.3798 21.9143 21.744 21.4096 21.744H11.5483V24.022H21.501C22.0057 24.022 22.4148 23.6577 22.4148 23.2084V22.5576Z"
      fill={color}
    />
    <path
      d="M19.2492 21.744V24.022H10.499C9.9943 24.022 9.58518 23.6577 9.58518 23.2084V22.5576C9.58518 22.1083 9.17603 21.744 8.67132 21.744H8.03163C7.52692 21.744 7.11778 21.3798 7.11778 20.9305L7.11779 17.0087C7.11779 16.5594 7.52693 16.1951 8.03164 16.1951H8.76272C9.26742 16.1951 9.67655 16.5594 9.67655 17.0087L9.67655 20.9305C9.67655 21.3798 10.0857 21.744 10.5904 21.744H19.2492Z"
      fill={color}
    />
    <path
      d="M22.4148 14.0105C22.4148 14.4599 22.824 14.8241 23.3287 14.8241H23.9684C24.4731 14.8241 24.8822 15.1883 24.8822 15.6376L24.8822 19.5595C24.8822 20.0088 24.4731 20.373 23.9684 20.373H23.2373C22.7326 20.373 22.3235 20.0088 22.3235 19.5595L22.3235 15.6376C22.3235 15.1883 21.9143 14.8241 21.4096 14.8241H11.5484V12.5462H21.501C22.0057 12.5462 22.4148 12.9104 22.4148 13.3597V14.0105Z"
      fill={color}
    />
    <path
      d="M19.2492 14.8241L19.2492 12.5462H10.499C9.9943 12.5462 9.58518 12.9104 9.58518 13.3597V14.0105C9.58518 14.4599 9.17603 14.8241 8.67133 14.8241H8.03164C7.52693 14.8241 7.11779 15.1883 7.11779 15.6376L7.11778 19.5595C7.11778 20.0088 7.52692 20.373 8.03163 20.373H8.76271C9.26741 20.373 9.67655 20.0088 9.67655 19.5595L9.67655 15.6376C9.67655 15.1883 10.0857 14.8241 10.5904 14.8241H19.2492Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6659 18.6298C11.6659 19.0791 12.075 19.4433 12.5797 19.4433H13.3108C13.8155 19.4433 14.2246 19.0791 14.2246 18.6298V17.9383C14.2246 17.489 13.8155 17.1247 13.3108 17.1247H12.5797C12.075 17.1247 11.6659 17.489 11.6659 17.9383V18.6298Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7754 18.6298C17.7754 19.0791 18.1845 19.4433 18.6892 19.4433H19.4203C19.925 19.4433 20.3341 19.0791 20.3341 18.6298V17.9383C20.3341 17.489 19.925 17.1247 19.4203 17.1247H18.6892C18.1845 17.1247 17.7754 17.489 17.7754 17.9383V18.6298Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.4608 8.02197C18.9655 8.02197 19.3746 8.38621 19.3746 8.83552V9.12026C19.3746 9.56957 19.7837 9.93381 20.2884 9.93381H20.9281C21.4328 9.93381 21.842 10.2981 21.842 10.7474V11.7326C21.842 12.1819 22.2511 12.5462 22.7558 12.5462H25.0862C25.5909 12.5462 26 12.9104 26 13.3597V14.0105C26 14.4599 25.5909 14.8241 25.0862 14.8241H15.5821C15.0774 14.8241 14.6683 14.4599 14.6683 14.0105V13.3597C14.6683 12.9104 15.0774 12.5462 15.5821 12.5462H18.3694C18.8741 12.5462 19.2832 12.1819 19.2832 11.7326V11.1135C19.2832 10.6641 18.8741 10.2999 18.3694 10.2999L16.1761 10.2999C15.6714 10.2999 15.2623 9.93567 15.2623 9.48636V8.83552C15.2623 8.38621 15.6714 8.02197 16.1761 8.02197L18.4608 8.02197Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5392 8.02197C13.0345 8.02197 12.6254 8.38621 12.6254 8.83552V9.12026C12.6254 9.56957 12.2163 9.93381 11.7116 9.93381H11.0719C10.5672 9.93381 10.158 10.2981 10.158 10.7474V11.7326C10.158 12.1819 9.74886 12.5462 9.24416 12.5462H6.91385C6.40914 12.5462 6 12.9104 6 13.3597V14.0105C6 14.4599 6.40914 14.8241 6.91385 14.8241H16.4179C16.9226 14.8241 17.3317 14.4599 17.3317 14.0105V13.3597C17.3317 12.9104 16.9226 12.5462 16.4179 12.5462H13.6306C13.1259 12.5462 12.7168 12.1819 12.7168 11.7326V11.1135C12.7168 10.6641 13.1259 10.2999 13.6306 10.2999L15.8239 10.2999C16.3286 10.2999 16.7377 9.93567 16.7377 9.48636V8.83552C16.7377 8.38621 16.3286 8.02197 15.8239 8.02197L13.5392 8.02197Z"
      fill={color}
    />
  </svg>
);

export default AvatarSix;
